<template>
  <div>
    <v-dialog name="dialog" />
    <div class="admin_title">公告管理</div>
    <!--右侧内容-->
    <div class="gj_top_class">
      <input name="" type="button" class="btn_s_gj" @click="search(filters)"/><input name="" type="text" class="put_gj" v-model="filters.title" @keyup.13="search(filters)"/>
      <select name="infotype" v-model="filters.type" @change="search(filters)">
        <option value="">选择类型</option>
        <option v-for="item in pool.information_type" v-bind:key="item.value" :value="item.value">{{item.label}}</option>
      </select>
      <a href="javascript:;" @click="to('information', 'void')">新增公告</a>
    </div>
    <div class="add_shijuan_con">
      <table id="customers">
        <tr>
          <th width="20%">标题</th>
          <th width="10%">分类</th>
          <th width="30%">内容</th>
          <th width="10%">上/下架</th>
          <th width="10%">审核状态</th>
          <th width="20%">操作</th>
        </tr>
        <tr v-for="item in lists" :key="item.id">
          <td>{{item.title}}</td>
          <td>{{getInfoLabel(item.type)}}</td>
          <td v-html="item.content" class="substr">
          </td>
          <td>{{item.state == '0' ? '下架' : '上架'}}</td>
          <td>{{item.audit == '0' ? '未审核' : '审核通过'}}</td>
          <td>
            <a href="javascript:;" class="red_font_a" @click="to('information', item.id)">编辑</a>
            <a href="javascript:;" class="red_font_a" v-if="item.state == '0'" @click="pub(item, '1')">上架</a>
            <a href="javascript:;" class="red_font_a" v-if="item.state == '1'" @click="pub(item, '0')">下架</a>
            <a href="javascript:;" class="red_font_a" v-if="item.audit == '0'" @click="audit(item.id)">审核</a>
            <a href="javascript:;" class="red_font_a" @click="del(item.id)">删除</a>
          </td>
        </tr>
      </table>
      <h5 class="none_ts" v-if="cntData <= 0">
        <img src="@/assets/images/none_data.jpg" alt="">
      </h5>
    </div>
    <!--/右侧内容-->
    <div class="zy_list_bottom" v-if="cntData > 0">
      <dl>
        <dt><!--input id="sel_1" onchange="selectAll()" type="checkbox" value="1" style="opacity: 1;"/> 全选 <input name="" type="button" value="批量上架" class="btn_zy_bottom" /> <input name="" type="button" value="批量下架"  class="btn_zy_bottom"/> <input name="" type="button" value="删除所选"  class="btn_zy_bottom" /-->共{{cntData}}条公告</dt>
        <dd>
          <paginate :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </dd>
      </dl>
    </div>
    <!--/右侧内容-->
  </div>
</template>
<script>
  import config from '@/config'
  import api from '@/api'
  import Paginate from 'vuejs-paginate'
  import utils from '@/utils'
  export default {
    components: { Paginate },
    data () {
      return {
        filters: {
          pageNo: 1,
          pageSize: 12,
          title: '',
          type: ''
        },
        lists: [],
        pages: 0,
        cntData: '',
        pool: {
          information_type: []
        }
      }
    },
    created () {
      this.search(this.filters)
      this.getTypes('information_type')
    },
    mounted () {
    },
    computed: {
    },
    methods: {
      getInfoLabel (type) {
        var r = null
        this.pool.information_type.forEach(function (o) {
          if (o.value == type) {
            r = o.label
          }
        })
        return r
      },
      to (path, id) {
        this.$router.push({
          path: path + '/' + id
        })
      },
      clickCallback (pageNum) {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      pub (item, type) {
        var text = (type == '0') ? '下架' : '上架'
        if (item.id) {
          var that = this
          this.confirmBox({
            title: text,
            text: '确认' + text + '吗?',
            yes: function () {
              var form = utils.deepCopy({}, item)
              form.state = type
              api.post(config.bylBaseCenterPath, '/noticeinfo/save', form, r => {
                that.$toasted.show('发布成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      audit (id) {
        if (id) {
          var that = this
          this.confirmBox({
            title: '审核',
            text: '确认审核吗?',
            yes: function () {
              api.post(config.bylBaseCenterPath, '/noticeinfo/updateAudit', {id: id, audit: '1'}, r => {
                that.$toasted.show('审核成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      del (id) {
        if (id) {
          var that = this
          this.confirmBox({
            title: '删除',
            text: '确认删除吗?',
            yes: function () {
              api.post(config.bylBaseCenterPath, '/noticeinfo/delete', { id: id }, r => {
                that.$toasted.show('删除成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      search (filters) {
        api.post(config.bylBaseCenterPath, '/noticeinfo/search', filters, (r) => {
          this.lists = r.data
          this.cntData = r.cntData // 总数
          this.pages = Math.ceil(r.cntData / this.filters.pageSize) // 页数
        })
      },
      getTypes (type) {
        api.get(config.bylBaseCenterPath, '/dict/getDictList', {type: type}, (r) => {
          if (r.data) {
            this.pool.information_type = r.data
          } else {
            this.pool.information_type = []
          }
        })
      }
    }
  }
</script>
<style lang="scss">
  .substr > * {
    width: 300px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/information/list.vue